import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ScreeningService } from '../services/screening.service';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-password-change',
  templateUrl: './password-change.component.html',
  styleUrls: ['./password-change.component.less']
})
export class PasswordChangeComponent implements OnInit {

  OldPassword: string;
  NewPassword: string;
  LoginError: boolean;
  ValidationMessage: string;

  constructor(private location: Router, private activatedRoute: ActivatedRoute, private scrn: ScreeningService, private auth: AuthService) {
    auth.titleBarText = "STP Login"
  }

  ngOnInit() {
    // this.activatedRoute.paramMap.subscribe(
    //   (params: ParamMap) => {
    //     this.redirectRoute = params.get('redirect');
    //   });

    if(!localStorage.getItem('STP-JWT')){
      this.auth.postLoginRedirect = '/pass/change';
      this.auth.hasRedirect = true;
      this.location.navigateByUrl('/auth')
    }
  }

  update(val: any) {
    console.log(val);
    if (val.name == 'OldPassword') {
      this.OldPassword = val.value;
    } else {
      this.NewPassword = val.value;
    }
  }
  continue() {
    this.auth.ChangePassword({old : this.OldPassword, new : this.NewPassword}).subscribe((rsp: any) => {
      console.log('PWReset call returned', rsp);
      this.location.navigateByUrl(this.auth.postLoginRedirect);
    },
      (err: any) => {
        this.LoginError = true;
        console.log('PWReset call returned', err);
        this.ValidationMessage = err.error;
      })
  }
}